'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawerMenuContainer = exports.drawerMenuBuilder = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _DrawerMenu = require('../../Presentational components/DrawerMenu/DrawerMenu');

var _DrawerMenu2 = _interopRequireDefault(_DrawerMenu);

var _actions = require('./actions');

var Actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var drawerMenuBuilder = exports.drawerMenuBuilder = function drawerMenuBuilder(mapStateToProps) {
  return (0, _reactRedux.connect)(mapStateToProps, Actions)(_DrawerMenu2.default);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appBar: state.app.drawerMenu.appBar,
    menu: state.app.drawerMenu.menu,
    header: state.app.drawerMenu.header,
    items: state.app.drawerMenu.items,
    children: state.app.drawerMenu.children
  };
};

var DrawerMenuContainer = exports.DrawerMenuContainer = drawerMenuBuilder(mapStateToProps);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/DrawerMenuContainer/DrawerMenuContainer.js
 ** module id = 465
 ** module chunks = 0
 **/